var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMultipleVideoSendingSupportFeatureFlag } from '../base/config/functions';
import { getLocalJitsiDesktopTrack, getLocalJitsiVideoTrack } from '../base/tracks/functions';
import { SET_SCREENSHOT_CAPTURE } from './actionTypes';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { createScreenshotCaptureSummary } from './functions';
import logger from './logger';
let screenshotSummary;
/**
 * Marks the on-off state of screenshot captures.
 *
 * @param {boolean} enabled - Whether to turn screen captures on or off.
 * @returns {{
    *      type: START_SCREENSHOT_CAPTURE,
    *      payload: enabled
    * }}
*/
function setScreenshotCapture(enabled) {
    return {
        type: SET_SCREENSHOT_CAPTURE,
        payload: enabled
    };
}
/**
* Action that toggles the screenshot captures.
*
* @param {boolean} enabled - Bool that represents the intention to start/stop screenshot captures.
* @returns {Promise}
*/
export function toggleScreenshotCaptureSummary(enabled) {
    return function (dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = getState();
            if (state['features/screenshot-capture'].capturesEnabled !== enabled) {
                if (!screenshotSummary) {
                    try {
                        screenshotSummary = yield createScreenshotCaptureSummary(state);
                    }
                    catch (err) {
                        logger.error('Cannot create screenshotCaptureSummary', err);
                    }
                }
                if (enabled) {
                    try {
                        const jitsiTrack = getMultipleVideoSendingSupportFeatureFlag(state)
                            ? getLocalJitsiDesktopTrack(state)
                            : getLocalJitsiVideoTrack(state);
                        yield screenshotSummary.start(jitsiTrack);
                        dispatch(setScreenshotCapture(enabled));
                    }
                    catch (_a) {
                        // Handle promise rejection from {@code start} due to stream type not being desktop.
                        logger.error('Unsupported stream type.');
                    }
                }
                else {
                    screenshotSummary.stop();
                    dispatch(setScreenshotCapture(enabled));
                }
            }
            return Promise.resolve();
        });
    };
}
